import { FC, MutableRefObject } from 'react';
import { Line, Text } from '@react-three/drei';
import { Group } from 'three';

import { textColor } from '../../../contants/3d-text-settings';

interface VerticalMeasurementProps {
  groupRef?: MutableRefObject<Group | null>;
  position: [number, number, number];
  rotation?: [number, number, number];
  textPosition?: [number, number, number];
  textValue: string;
  fontSize: number;
  height: number;
}

export const VerticalMeasurement: FC<VerticalMeasurementProps> = ({
  groupRef,
  position,
  rotation = [0, 0, 0],
  textPosition = [0.12, 0, 0],
  textValue,
  fontSize,
  height
}) => {
  const halfHeight = height / 2;

  return (
    <group ref={groupRef} position={position} rotation={rotation}>
      <Text
        color="#111111"
        fontSize={fontSize}
        position={textPosition}
        lineHeight={1}
        maxWidth={1000}
        letterSpacing={0.02}
        font="/Roboto-Bold.ttf"
        anchorX="left"
        anchorY="middle"
      >
        {textValue}
      </Text>

      <Line
        lineWidth={1}
        points={[
          [0, halfHeight, 0],
          [0, -halfHeight, 0]
        ]}
        color={textColor}
        scale={1}
      />

      <Line
        lineWidth={1}
        points={[
          [-0.04, halfHeight, 0],
          [0.04, halfHeight, 0]
        ]}
        color={textColor}
        scale={1}
      />

      <Line
        lineWidth={1}
        points={[
          [-0.04, -halfHeight, 0],
          [0.04, -halfHeight, 0]
        ]}
        color={textColor}
        scale={1}
      />
    </group>
  );
};
